import React from "react";

export const defaultRenderCell = (cell) => cell.render("Cell")
export const DefaultTableHeader = ({className = '', headerGroups, staticHeaders = ''}) => (
    <thead
        className={`datatable__thead ${className ? className + '__thead' : ''}`}
    >

    {
        headerGroups.map((headerGroup) => (
            <tr
                className={`datatable__tr ${className ? className + '__tr' : ''}`}
                {...headerGroup.getHeaderGroupProps()}
            >
                {staticHeaders}

                {
                    headerGroup.headers.map((column) => (
                        <th
                            className={`datatable__th ${className ? className + '__th' : ''}`}
                            {...column.getHeaderProps()}
                        >
                            {column.render("Header")}

                        </th>
                    ))
                }
            </tr>
        ))
    }
    </thead>
)





export const DefaultCell = ({cell, renderCell, className = ''}) => (
    <td
        {...cell.getCellProps()}
    >
        {renderCell(cell)}
    </td>
)

export const DefaultTableRow = ({row, ...rest}) => (
    row.cells.map((cell, j) => {
        return (
            <DefaultCell
                key={j.toString()}
                cell={cell}
                {...rest}
            />
        );
    })
)
